import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { RootState } from "../../store";
import ProgressBar from "../ProgressBar";

const Circle = styled.div<{
  activeStep?: boolean;
}>`
  min-width: 35px; /*was width*/
  height: 35px;
  line-height: 35px;
  border-radius: 50%;
  text-align: center;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.lightGray};
  position: relative;
  z-index: 1;
  ${(props) =>
    props.activeStep &&
    `
        background-color: ${props.theme.colors.primary};
        color: #fff
    `}
`;

const FormStepContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0 28px;
  justify-content: space-between;
`;

const FormSteps = () => {
  const currentStep = useSelector(
    (state: RootState) => state.multistepModel.curentStep
  );

  return (
    <FormStepContainer>
      <Circle activeStep={currentStep >= 1}>1</Circle>
      <ProgressBar progress={currentStep >= 2 ? 100 : 0} />
      <Circle activeStep={currentStep >= 2}>2</Circle>
      <ProgressBar progress={currentStep >= 3 ? 100 : 0} />
      <Circle activeStep={currentStep >= 3}>3</Circle>
      <ProgressBar progress={currentStep >= 4 ? 100 : 0} />
      <Circle activeStep={currentStep >= 4}>4</Circle>
      <ProgressBar progress={currentStep >= 5 ? 100 : 0} />
      <Circle activeStep={currentStep >= 5}>5</Circle>
    </FormStepContainer>
  );
};

export default FormSteps;
